import { Button } from "@aircall/tractor";
import { useTranslation } from "react-i18next";
import { TranscriptionLowConfidence } from "../TranscriptionEmptyMessage/components/TranscriptionLowConfidence";
import { TranscriptionIllustrationLayout } from "../TranscriptionIllustrationLayout";

type TranscriptionLowConfidenceWithTranscriptProps = {
  onClick: () => void;
};

export function TranscriptionLowConfidenceWithTranscript({
  onClick,
}: TranscriptionLowConfidenceWithTranscriptProps) {
  const { t } = useTranslation();

  return (
    <TranscriptionIllustrationLayout>
      <TranscriptionLowConfidence />
      <Button
        data-test="low-confidence-transcription-display-cta"
        onClick={onClick}
        size="large"
      >
        {t("show_transcript")}
      </Button>
    </TranscriptionIllustrationLayout>
  );
}
